import OlMap from "@/components/ol-map";
import { defaultInteractions, defaultPointStyle, newDrawInteraction, newPointFeatureFromCoords, newVectorLayer, newWMSTileLayer } from "@/components/ol-map/helpers";
import { CommitableSlidePanel } from "@/components/slide-panel";
import LocMapMixin from '@/lib/mixins/loc-map';
import RightsAware from '@/lib/mixins/rights-aware';
import BeanCoord from '@/lib/models/bean-coord';
import { loadCavitesByCenter } from '@/lib/services';
import { Component, Mixins, Watch } from "vue-property-decorator";
import Icon from '@/components/icon';

@Component
export default class PanelLocMap extends Mixins(CommitableSlidePanel, RightsAware, LocMapMixin) {

  protected isDrawActive: boolean = false;
  protected drawLayer: any = null;
  protected assocLayer: any = null;
  protected lastClickedFeature: any = null;

  created() {
    this.assocLayer = newVectorLayer({ name: "assocLayer", style: defaultPointStyle({radius: 5, fill: "#EE7820", stroke: "#404040"}) });
    this.drawLayer = newVectorLayer({ name: "drawLayer", style: defaultPointStyle({radius: 6, fill: "#209CEE", stroke: "#704040", strokeWidth: 3}) });
  }

  get rootClasses() {
    return ["panel-loc-map"];
  }

  get drawPointInteraction() {
    const inter = newDrawInteraction({
      source: this.drawLayer.getSource(),
      type: "Point",
      active: this.isDrawActive
    });
    inter.on("drawend", evt => this.handleDrawEnd(evt.feature));
    return inter;
  }

  get layers() {
    return [
      ...(window as any).rootConfig.MAP.LAYERS.map(pl => newWMSTileLayer(pl)),
      this.assocLayer,
      this.drawLayer
    ];
  }

  get providedCenter() {
    if (this.cavCoords) {
      return this.cavCoords.asWgs84().asArray();
    } else if (this.commune) {
      return [this.commune.longi, this.commune.lat];
    }
    return null;
  }

  get isCommitable() {
    return !!this.selectedCoordinates;
  }

  get olMap() {
    return this.$refs.mainMap as OlMap;
  }

  onToggleDrawPoint() {
    this.isDrawActive = !this.isDrawActive;
  }

  @Watch("isDrawActive")
  onDrawActiveChange() {
    this.drawPointInteraction.setActive(this.isDrawActive);
  }

  @Watch("selectedCoordinates", {immediate: true})
  async onSelectedCoordinatesChange() {
    if (this.selectedCoordinates) {
      await this.loadCavitesAssociees();
    }
  }

  handleDrawEnd(feature) {
    const { resolution, metersPerUnit, zoom } = this.olMap.getCenterAndZoom();
    this.drawLayer.getSource().clear();
    let featuresGeoJSon = this.olMap.features2geojson([feature]),
        geometry = featuresGeoJSon.features[0].geometry;
    this.selectedCoordinates = BeanCoord.fromArray(geometry.coordinates)
      .inject({resolution: resolution * metersPerUnit * Math.cos(geometry.coordinates[1] * Math.PI / 180)})
      .project(this.preferedEpsg)
      .mutRound(this.displayedCoordinatesPrecision);
    this.isDrawActive = false;
    setTimeout(() => {
      this.olMap.zoomAndCenterTo({center: geometry.coordinates, zoom: Math.max(zoom, 16)});
    }, 500);
  }

  async loadCavitesAssociees() {
    this.loading++;;
    const cavs = await loadCavitesByCenter({
      coords: this.selectedCoordinates.asWgs84(),
      distance: (window as any).rootConfig.MAP.CAV_ASSOC_MIN_DIST,
      numCavite: this.numCavite
    });
    this.loading--;
    this.assocLayer.getSource().clear();
    cavs.forEach(bc => {
      this.assocLayer.getSource().addFeature(
        newPointFeatureFromCoords({
          coords: bc.asWgs84().asArray(),
          properties: {
            numCavite: bc.userInfo
          }
        })
      );
    });
  }

  async mounted() {
    //append feature if a beanCoord is provided
    if (this.selectedCoordinates) {
      this.drawLayer.getSource().addFeature(
        newPointFeatureFromCoords({
          coords: this.selectedCoordinates.asWgs84().asArray()
        })
      );
    }
  }


  renderOveredFeaturesInfo() {
    if (this.overedFeatures.length) {
      return <span>{this.overedFeatures[0].getProperties().numCavite}</span>;
    }
    return null;
  }
  

  renderHead() {
    return <span>Localiser sur carte</span>
  }

  renderBody() {
    return (
      <div style="height: 70vh; position: relative">
        <OlMap ref="mainMap"
          layers={this.layers}
          zoom={this.zoom}
          interactions={[
            ...this.mapDefaultInteractions,
            this.drawPointInteraction
          ]}
          center={this.providedCenter as [number, number]}
          onMapMouseMove={({coordinate, features}) => {
            this.overedCoordinates = BeanCoord.fromArray(coordinate);
            this.overedFeatures = features;
          }}
        />
        {this.renderOveredCoordinates()}
        {!this.isReadonly && (
        <div class="map-tb">
          <div class={`map-tb-btn ${this.isDrawActive ? 'is-active': ''}`} onClick={this.onToggleDrawPoint}>
            <Icon icon="dot-circle" class="icon info"/>
          </div>
        </div>
        )}
      </div>
    );
  }

  onClickCommit(...args) {
    if (this.selectedCoordinates) {
      this.commit({data: this.selectedCoordinates});
    }
  }

  onClickCancel() {
    this.cancel();
  }
  
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-0e48763a/panel-loc-map.tsx" });